export enum EXTERNAL_SOURCE {
  YOUTUBE = 'youtube',
  YOUTUBE_VIDEO = 'yv',
  YOUTUBE_PLAYLIST = 'yp',
  SPOTIFY = 'spotify',
  SPOTIFY_ALBUMS = 'sa',
  SPOTIFY_PLAYLISTS = 'sp',
  USER_PLAYLIST = 'up',
}
